'use strict';

wbApp.controller('AddressSelectorCtrl', ['$scope', 
function ($scope) {

    $scope.onAdd = function () {
        $scope.onAddAddress($scope.recipient);
    }

    $scope.isAddDisabled = function () {

        if (!$scope.recipient) {
            return true;
        }

        var groupType = parseInt($scope.recipient.recipientGroupType);

        switch (groupType) {
            case 1:
                return !$scope.recipient.userId;
            case 2:
                return !$scope.recipient.semesterId || !$scope.recipient.courseId;
            case 3:
                return !$scope.recipient.semesterId || !$scope.recipient.courseId || !$scope.recipient.courseScheduleId;
            case 4:
                return !$scope.recipient.semesterId || !$scope.recipient.classroomId;
            case 5:
                return !$scope.recipient.classroomId || !$scope.recipient.toDate;
            case 6:
                return !$scope.recipient.semesterId || !$scope.recipient.compensationGroupId;
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
                return !$scope.recipient.semesterId;
            case 12:
                return !$scope.recipient.semesterId || !$scope.recipient.semester2Id;

            case 13:
            case 14:
                return !$scope.recipient.semesterId;
            case 15:
                return !$scope.recipient.toDate;
            case 16:
                return !$scope.recipient.studentId;
            case 17:
                return !$scope.recipient.semesterId || !$scope.recipient.courseId;
        }
    }
}]);
